<template>
	<v-row class="d-flex justify-center">
		<v-dialog v-model="dialog" color="" width="400">
			<v-card class="py-2 px-2">
				<v-card-title class="title justify-center py-1">Edit Employees</v-card-title>
				<v-divider class="mx-4" />
				<v-form>
					<div class="d-flex">
						<v-col cols="6">
							<v-text-field label="Name"></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="Type"></v-text-field>
						</v-col>
					</div>
				</v-form>
				<v-card-actions>
					<v-btn color="primary">save</v-btn>
					<v-btn text @click=" dialog = false ">cancle</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-row align="center">
			<v-col cols="10" class="py-0">
				<span class="title">Manage categories</span>
			</v-col>
		</v-row>
		<v-spacer />
		<v-col cols="2" class="d-flex align-center my-2 justify-center">
			<v-text-field placeholder="Search" hide-details dense />
		</v-col>
		<v-col cols="12" class="py-0">
			<v-data-table
			:headers="headers"
			:items="desserts"
			:items-per-page=20
			class="elevation-1"
			:footer-props="{
				itemsPerPageOptions: [20, 30, 40, -1]
			}"
			>
				<template v-slot:item.actions="{  }">
					<v-btn icon>
						<v-icon
							meduim
							class="mr-2"
							@click=" dialog = true"
							color="edit-color"
						>
							mdi-pencil
						</v-icon>
					</v-btn>
					<!-- <v-btn icon :to="{ name: 'employee-bee' }">
						<v-icon
							meduim
							color="primary"
						>
							mdi-file-document-outline
						</v-icon>
					</v-btn> -->
				</template>
			</v-data-table>
		</v-col>
	</v-row>
</template>

<script>
export default {
	data () {
		return {
			dialog: false,

			headers: [
				{ text: 'Name', value: 'name', align: 'center' },
				{ text: 'Type', value: 'type', align: 'center' },
				{ text: 'situation', value: 'situation', align: 'center' },
				{ text: 'actions', value: 'actions', align: 'center' }
			],
			desserts: [
				{
					name: 'Rasha',
					type: 'Developer',
					situation: 'Active'
				}
			]
		}
	}
}
</script>
